import React, { useContext, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import '../styles/Header.css';
import logo from '../images/logo_1.png';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const Header = ({ onSidebarToggle, toast }) => {
    const { user, logoutUser } = useContext(AuthContext); // Extrae la función de cierre de sesión
    const [visible, setVisible] = useState(false); // Estado para controlar la visibilidad del confirm dialog
    const navigate = useNavigate()

    // Lógica para mostrar el confirm dialog
    const confirmLogout = () => {
        confirmDialog({
            message: '¿Estás seguro de que deseas cerrar sesión?',
            header: 'Confirmación de Cierre de Sesión',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: async () => {
                const success = await logoutUser(user?.token); // Llama a la función de cerrar sesión si el usuario confirma
                if (success) {
                    toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Usuario deslogeado exitosamente!', life: 2000});
                    setTimeout(() => {
                        navigate('/'); // Redirige a la ruta después de 2 segundos
                    }, 3000);
                }
            },
            reject: () => setVisible(false)  // Cierra el dialogo si el usuario cancela
        });
    };

    // Contenido del logo a la izquierda
    const leftContents = (
        <div style={{ paddingLeft: "6vw" }}>
            <img src={logo} alt="Logo" className="logo" style={{ height: "4.3vw" }} />
            <Button icon="pi pi-bars" rounded text severity="secondary" onClick={onSidebarToggle} aria-label="Menu" style={{ marginBottom:"20px" }} />
        </div>
    );

    // Contenido del usuario en el centro
    const centerContents = (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <p style={{ margin: 0 }}>Usuario: {user?.username}</p> {/* Cambia esto según los datos del usuario */}
        </div>
    );

    // Contenido del botón de iniciar sesión a la derecha
    const rightContents = (
        <div style={{ paddingRight: "5vw" }}>
            <Button label="Cerrar Sesión" severity="danger" size='small' onClick={confirmLogout} />
        </div>
    );

    return (
        <header className="nav-static" style={{ borderBottom: "3px solid #07b6d5" }}>
            <Toolbar left={leftContents} center={centerContents} right={rightContents} style={{ padding: "0.1vw", backgroundColor: "#F1F1F1", minHeight:"5vw", maxHeight:"5vw" }} />
            <ConfirmDialog visible={visible} onHide={() => setVisible(false)} />
        </header>
    );
};

export default Header;
